import { useState } from 'react';

import { ThanksModal, thanksTable } from 'src/common/utils/ThanksModal';
import {
  convertToString,
  TranslationFunction,
} from 'src/common/hooks/widgets/useTranslation';

export interface thanksProps {
  bpName: string;
  demo?: string;
  useTranslation: TranslationFunction;
}

const Thanks = ({ bpName, useTranslation }: thanksProps) => {
  const [showThanksModal, setShowThanksModal] = useState(true);

  const titleThanks: thanksTable[] = [
    {
      group: 'title',
      value: convertToString(useTranslation('thank_text', true)),
    },
    {
      group: 'widgetTitle2',
      value: '',
    },
  ];

  const widgetTitleThanks: thanksTable[] = [
    {
      group: 'widgetTitle1',
      value: '',
    },
  ];
  const contentThanks: thanksTable[] = [];
  bpName &&
    contentThanks.push({
      group: convertToString(useTranslation('bp_title', true)),
      value: bpName,
    });

  const buttonThanks: thanksTable[] = [
    {
      group: 'button1',
      value: convertToString(useTranslation('return_assessment', true)),
    },
  ];

  return (
    <div>
      <ThanksModal
        showThanksModal={showThanksModal}
        pageTitle="SPSS Purchasing Advisor Self Assessment Page"
        object="SPSS Purchasing Advisor Self Assessment Page"
        productTitle={'SPSS Purchasing Advisor Self Assessment'}
        pageUrl={'/products/spss-statistics/pricing'}
        location={'Assessment'}
        titleThanks={titleThanks}
        widgetTitleThanks={widgetTitleThanks}
        contentThanks={contentThanks}
        buttonThanks={buttonThanks}
        setShowThanksModal={setShowThanksModal}
      />
    </div>
  );
};

export default Thanks;
